var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1665 13C24.3854 12.7812 24.6452 12.6076 24.9312 12.4891C25.2171 12.3707 25.5236 12.3097 25.8332 12.3097C26.1427 12.3097 26.4492 12.3707 26.7352 12.4891C27.0211 12.6076 27.281 12.7812 27.4998 13C27.7187 13.2189 27.8923 13.4788 28.0108 13.7647C28.1292 14.0507 28.1902 14.3572 28.1902 14.6667C28.1902 14.9762 28.1292 15.2827 28.0108 15.5687C27.8923 15.8547 27.7187 16.1145 27.4998 16.3334L16.2498 27.5834L11.6665 28.8334L12.9165 24.25L24.1665 13Z",
    stroke: "#5A6376",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2c76bc34.svg";
export { ForwardRef as ReactComponent };